module.exports = __webpack_public_path__ + "assets/images/XCD50.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/XCD50.png
// module id = 1479
// module chunks = 1